module.exports = __webpack_public_path__ + "img/document.35b521ab.svg";